/**
 * Enum of all icon names. Use when referring to an icon by name (e.g. configs, props).
 * Icon components live in this folder and are exported from the index.
 */
export enum IconName {
  Copy = "Copy",
  ChevronDown = "ChevronDown",
  DotsHorizontal = "DotsHorizontal",
  ExclamationCircle = "ExclamationCircle",
  ExternalLink = "ExternalLink",
  Eye = "Eye",
  EyeOff = "EyeOff",
  Google = "Google",
  Pencil = "Pencil",
  Reply = "Reply",
  Search = "Search",
  Smile = "Smile",
  Share = "Share",
  Trash = "Trash",
  PenLine = "PenLine",
  UserX = "UserX",
}
